import { render, staticRenderFns } from "./activity-list-email.vue?vue&type=template&id=7115f0fc&scoped=true"
import script from "./activity-list-email.vue?vue&type=script&lang=js"
export * from "./activity-list-email.vue?vue&type=script&lang=js"
import style0 from "./activity-list-email.vue?vue&type=style&index=0&id=7115f0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7115f0fc",
  null
  
)

export default component.exports